<template>
  <div class="permissions aside__item -full-" style="width: 880px">
    <div class="permissions__admin">
      <SwitchBlock
        v-model="permissions.isAdmin"
        text="Администратор"
        @input="updatePermissions"
      ></SwitchBlock>
    </div>
    <template v-for="(permissionObject, permissionKey) in permissions">
      <div
        v-if="permissionKey !== 'isAdmin' && permissionKey !== 'id'"
        :key="permissionKey"
        class="permissions__block"
      >
        <p class="permissions__name">{{ getPermissionName(permissionKey) }}</p>
        <div class="permissions__controls">
          <div v-for="(value, key) in permissionObject" :key="key" class="permissions__checks">
            <div class="permissions__checks-title">{{ getTypeTitle(key) }}</div>
            <RadioBlock
              v-for="idx in [3, 2, 1]"
              :key="idx"
              class="options__check"
              text=""
              :value="permissions[permissionKey][key]"
              :checked="permissions[permissionKey][key] == idx - 1"
              :name="permissionKey + '_' + key"
              text-class="options__text"
              @change="changeValue({ permissionKey, key, idx })"
            ></RadioBlock>
          </div>
        </div>
        <div class="permissions__descriptions">
          <p
            v-for="(desc, idx) in getDescriptions(permissionKey)"
            :key="idx"
            class="permissions__description"
          >
            {{ desc }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import getPermissionName from '@/constants/permissions/getPermissionName';
import getPermissionDescriptions from '@/constants/permissions/getPermissionDescriptions';
import { mapState } from 'vuex';

export default {
  props: ['propPermissions'],
  data: () => ({
    permissions: {
      isAdmin: false
    }
  }),
  computed: {
    ...mapState('usersGroups', {
      storeGroup: s => s.aside.data.group
    })
  },
  async mounted() {
    await this.$store.dispatch('usersGroups/getGroupPermission', this.storeGroup.id);
    this.permissions = _.cloneDeep(this.storeGroup.permissions);
  },
  methods: {
    getTypeTitle(key) {
      switch (key) {
        case 'update':
          return 'Правка';
        case 'read':
          return 'Просмотр';
        case 'delete':
          return 'Удаление';
        case 'create':
          return 'Создание';
        default:
          return '';
      }
    },
    getPermissionName(key) {
      return getPermissionName(key);
    },
    getDescriptions(key) {
      return getPermissionDescriptions(key);
    },
    changeValue({ permissionKey, key, idx }) {
      this.permissions[permissionKey][key] = '' + idx - 1;
      this.$emit('updatePermissions', this.permissions);
    },
    updatePermissions() {
      this.$emit('updatePermissions', this.permissions);
    }
  }
};
</script>
